<app-login-template
  registerPath="/signup"
  forgotPasswordPath="/forgot-password-get-link"
  [title]="'LOGIN.PAGE_TITLE' | translate"
>
  <div class="separator">
    <div class="separator-line"></div>
    <span class="separator-text">{{ "LOGIN.OR_SEPARATOR" | translate }}</span>
    <div class="separator-line"></div>
  </div>

  <div class="flex column social-logins">
    <app-google-sso-button [ssoUrl]="googleSSOUrl"></app-google-sso-button>

    <a
      routerLink="/sso/szamlazzhu"
      style="text-decoration: none; display: block"
    >
      <button
        type="button"
        payee-button
        width="wide"
        height="tall"
        color="white"
        [isBorderButton]="true"
      >
        <span class="social-login-text">
          <img
            src="assets/szamlazzhu_logo-vertical-2_orange.png"
            alt="Számlázz.hu"
            class="szamlazzhu-logo"
          />
          {{ "LOGIN.CONTINUE_WITH_SZAMLAZZ" | translate }}
        </span>
      </button>
    </a>
  </div>
</app-login-template>
